import styled from "styled-components";

export const Container = styled.div<{ backgroundColor?: string }>(({ theme, backgroundColor }) => ({
    padding: `${theme.spacing.xSmall} 0 14px ${theme.spacing.medium}`,
    position: "relative",
    borderRadius: `0 0 ${theme.spacing.medium} ${theme.spacing.medium}`,
    background:
        backgroundColor ??
        `linear-gradient(96deg, rgba(255, 87, 211, 0.06) 1.36%, rgba(252, 200, 239, 0.06) 30.38%, rgba(255, 255, 255, 0.06) 50.53%)`,
}));

export const Content = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ImageContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: "-6px",
    right: theme.spacing.xSmall,
}));

export const Separator = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    max-width: 248px;
    width: 100%;
    height: 1px;
    opacity: 0.4;
    background: linear-gradient(
        90deg,
        rgba(255, 75, 208, 0.26) 0%,
        rgba(255, 75, 208, 0.26) 64.2%,
        rgba(255, 75, 208, 0) 100%
    );
`;

export const ClickableText = styled.span(() => ({
    fontWeight: 600,
    display: "inline-block",
    lineHeight: 1,
    borderBottom: "1.5px dashed #793066",
    cursor: "pointer",
}));
